import React from 'react'
import { Table, Space, Button, Tooltip, Typography, theme } from 'antd'
import { EditOutlined, FileTextOutlined } from '@ant-design/icons'
import { formatDateTime, getUrgencyTag, getStatusBadge } from '../utils/formatters'
import { hexToRGBA } from '../../../../lib/utils'

const { Text } = Typography

const SurgeryTable = ({ data, handleShowDetails }) => {
  const { token } = theme.useToken()

  const columns = [
    {
      title: 'Patient',
      dataIndex: 'patientName',
      key: 'patientName',
      render: (text, record) => (
        <Space direction='vertical' size={0}>
          <Text>{text}</Text>
          <Text type='secondary' style={{ fontSize: '12px' }}>
            {record.patientId}
          </Text>
        </Space>
      ),
      sorter: (a, b) => a.patientName.localeCompare(b.patientName)
    },
    {
      title: 'Surgery Type',
      dataIndex: 'surgeryType',
      key: 'surgeryType',
      sorter: (a, b) => a.surgeryType.localeCompare(b.surgeryType)
    },
    {
      title: 'Scheduled Date/Time',
      dataIndex: 'scheduledDateTime',
      key: 'scheduledDateTime',
      render: (date) => formatDateTime(date),
      sorter: (a, b) => new Date(a.scheduledDateTime) - new Date(b.scheduledDateTime)
    },
    {
      title: 'Duration',
      dataIndex: 'duration',
      key: 'duration',
      render: (mins) => `${mins} min`,
      sorter: (a, b) => a.duration - b.duration
    },
    {
      title: 'Surgeon',
      dataIndex: 'assignedSurgeon',
      key: 'assignedSurgeon',
      sorter: (a, b) => a.assignedSurgeon.localeCompare(b.assignedSurgeon)
    },
    {
      title: 'Theatre',
      dataIndex: 'surgeryRoom',
      key: 'surgeryRoom'
    },
    {
      title: 'Urgency',
      dataIndex: 'urgency',
      key: 'urgency',
      render: (urgency) => getUrgencyTag(urgency)
    },
    {
      title: 'Status',
      dataIndex: 'preOpStatus',
      key: 'preOpStatus',
      render: (status) => getStatusBadge(status)
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space size='small'>
          <Tooltip title='View Details'>
            <Button
              icon={<FileTextOutlined style={{ color: token.colorPrimary }} />}
              size='small'
              onClick={() => handleShowDetails(record)}
              style={{
                background: hexToRGBA(token.colorPrimary, 0.1),
                borderColor: token.colorPrimary
              }}
            />
          </Tooltip>
          <Tooltip title='Edit Surgery'>
            <Button
              icon={<EditOutlined style={{ color: token.colorInfo }} />}
              size='small'
              style={{
                background: hexToRGBA(token.colorInfo, 0.1),
                borderColor: token.colorInfo
              }}
            />
          </Tooltip>
        </Space>
      )
    }
  ]

  return <Table columns={columns} dataSource={data} rowKey='surgeryId' pagination={{ pageSize: 10 }} />
}

export default SurgeryTable
